
export const setCookie = function(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var ck = cname + "=" + cvalue + ";expires="+d.toUTCString() + ";domain=;path=/";
	document.cookie = ck;
}

export const getCookie = function(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}


// WEBPACK FOOTER //
// /data/web/app/themes/epv/bs-embeds/src/helpers/cookies.js